// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"3329421f","85":"b6ef7094","142":"ec68eecf","358":"44a314f9","548":"21e143df","571":"491e95ee","632":"f0f58840","669":"ac258a78","734":"b7dd13dd","744":"ac010fce","823":"1cf53a4e","836":"1a19e764","868":"fc48033c"}[chunkId] + ".chunk.js";
};